import _ from 'lodash';
import type { ReactNode, VoidFunctionComponent } from 'react';

import { getErrorMessage } from '../../../../ReactQuery';
import FallbackImage from '../../../generic/FallbackImage';
import List from '../../../generic/List';
import type { DependencyForAPI } from '../../../../../shared/dependenciesV2';

import VendoredDependencyRow from './VendoredDependencyRow';

type Props = {
  isLoading: boolean;
  error: Error | null;
  dependencies: DependencyForAPI[];
};

/**
 * Renders the list of vendored dependencies in a table format.
 * @param {Props} props - The props for the component.
 */
const VendoredDependenciesTable: VoidFunctionComponent<Props> = ({
  isLoading,
  error,
  dependencies,
}) => {
  if (isLoading) {
    return ( // Use of Fragment here to help Typescript
      <>
        {_.times<ReactNode>(10, () => (
          <List.RowLoading />
        ))}
      </>
    );
  }

  if (error) {
    return (
      <FallbackImage src="error-plug" alt="Something went wrong">
        <div>{getErrorMessage(error)}</div>
      </FallbackImage>
    );
  }

  if (dependencies.length === 0) {
    return (
      <FallbackImage src="no-data" alt="Not found">
        No vendored dependencies found.
      </FallbackImage>
    );
  }

  return ( // Use of Fragment here to help Typescript
    <>
      {dependencies.map(dependency => (
        <VendoredDependencyRow key={dependency.locator} dependency={dependency} />
      ))}
    </>
  );
};

export default VendoredDependenciesTable;
